module.exports = __webpack_public_path__ + "img/ECONE-AGENDA1.d6a111dc.svg";